import * as React from 'react';

import Button from '../core/Button/Button';
import Dialog, { type DialogProps, DialogSize } from '../core/Dialog/Dialog';

export interface UnsavedChangesDialogProps extends DialogProps {
  confirm: () => void;
}

export default function UnsavedChangesDialog(props: UnsavedChangesDialogProps) {
  const { confirm, isOpen, onClose } = props;

  return (
    <Dialog
      size={DialogSize.LARGE}
      isOpen={isOpen}
      onClose={onClose}
      title="Leave this page?"
      cancelButtonText="Stay"
      actions={<Button onClick={confirm}>Yes, Leave</Button>}
    >
      Your changes have not been saved. Are you sure you want to leave this page?
    </Dialog>
  );
}
